/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-source': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<defs><path pid="0" d="M5.693.088a.5.5 0 0 1 .566 0l5.523 3.771a.5.5 0 0 1 .218.413V11.5a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5V4.272a.5.5 0 0 1 .216-.412zm.284 1.018L1 4.534V11h1.66V7.811a.5.5 0 0 1 .41-.492l.09-.008h5.68a.5.5 0 0 1 .492.41l.008.09V11H11V4.535L5.977 1.106zm2.362 7.205H3.66V11h4.68l-.001-2.689zm.508-3.325c.272 0 .493.224.493.5 0 .246-.174.45-.404.492l-.089.008H3.153a.496.496 0 0 1-.493-.5c0-.245.174-.45.404-.491l.089-.009h5.694z" id="svgicon-icon-source-a"/></defs><use _fill="#006064" fill-rule="nonzero" xlink:href="#svgicon-icon-source-a"/>'
  }
})
